import { render, staticRenderFns } from "./ReRuleConfig.vue?vue&type=template&id=f387db64&scoped=true"
import script from "./ReRuleConfig.vue?vue&type=script&lang=js"
export * from "./ReRuleConfig.vue?vue&type=script&lang=js"
import style0 from "./ReRuleConfig.vue?vue&type=style&index=0&id=f387db64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f387db64",
  null
  
)

export default component.exports